<template>
  <div class="list-page">
    <div class="list-content">
      <p class="title">{{ $t("safeTitle1") }}</p>
      <a
        class="item"
        v-for="i in 10"
        :key="`safe-${i}`"
        @click="toHmt($t('safeContent' + i), $t('safeUrl' + i))"
        >{{ $t("safeContent" + i) }}</a
      >
      <p class="title">{{ $t("safeTitle2") }}</p>
      <a
        class="item"
        v-for="i in 7"
        :key="`safe-${i + 10}`"
        @click="toHmt($t('safeContent' + (i + 10)), $t('safeUrl' + (i + 10)))"
        >{{ $t("safeContent" + (i + 10)) }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SafeKnow",
};
</script>

<style scoped>
</style>
